//# sourceMappingURL=svg.mjs.map
/// <reference types="./svg.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $attribute from "../../redraw/dom/attribute.mjs";
import { toProps as to_props } from "./html.ffi.mjs";

const convert_children = true;

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/a)
 */
export function a(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("a", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/animate)
 */
export function animate(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("animate", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/animateMotion)
 */
export function animate_motion(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("animateMotion", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/animateTransform)
 */
export function animate_transform(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("animateTransform", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/circle)
 */
export function circle(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("circle", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/clipPath)
 */
export function clip_path(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("clipPath", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/defs)
 */
export function defs(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("defs", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/desc)
 */
export function desc(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("desc", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/discard)
 */
export function discard(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("discard", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/ellipse)
 */
export function ellipse(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("ellipse", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feBlend)
 */
export function fe_blend(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feBlend", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feColorMatrix)
 */
export function fe_color_matrix(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feColorMatrix", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feElementTransfer)
 */
export function fe_component_transfer(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feElementTransfer", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feComposite)
 */
export function fe_composite(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feComposite", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feConvolveMatrix)
 */
export function fe_convolve_matrix(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feConvolveMatrix", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feDiffuseLighting)
 */
export function fe_diffuse_lighting(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feDiffuseLighting", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feDisplacementMap)
 */
export function fe_displacement_map(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feDisplacementMap", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feDistantLight)
 */
export function fe_distant_light(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feDistantLight", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feDropShadow)
 */
export function fe_drop_shadow(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feDropShadow", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feFlood)
 */
export function fe_flood(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feFlood", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feFuncA)
 */
export function fe_func_a(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feFuncA", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feFuncB)
 */
export function fe_func_b(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feFuncB", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feFuncG)
 */
export function fe_func_g(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feFuncG", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feFuncR)
 */
export function fe_func_r(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feFuncR", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feGaussianBlur)
 */
export function fe_gaussian_blur(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feGaussianBlur", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feImage)
 */
export function fe_image(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feImage", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feMerge)
 */
export function fe_merge(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feMerge", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feMergeNode)
 */
export function fe_merge_node(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feMergeNode", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feMorphology)
 */
export function fe_morphology(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feMorphology", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feOffset)
 */
export function fe_offset(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feOffset", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/fePointLight)
 */
export function fe_point_light(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("fePointLight", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feSpecularLighting)
 */
export function fe_specular_lighting(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feSpecularLighting", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feSpotLight)
 */
export function fe_spot_light(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feSpotLight", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feTile)
 */
export function fe_tile(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feTile", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/feTurbulence)
 */
export function fe_turbulence(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("feTurbulence", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/filter)
 */
export function filter(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("filter", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/foreignObject)
 */
export function foreign_object(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("foreignObject", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/g)
 */
export function g(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("g", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/hatch)
 */
export function hatch(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("hatch", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/hatchpath)
 */
export function hatchpath(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("hatchpath", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/image)
 */
export function image(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("image", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/line)
 */
export function line(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("line", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/linearGradient)
 */
export function linear_gradient(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("linearGradient", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/marker)
 */
export function marker(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("marker", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/mask)
 */
export function mask(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("mask", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/metadata)
 */
export function metadata(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("metadata", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/mpath)
 */
export function mpath(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("mpath", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/path)
 */
export function path(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("path", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/pattern)
 */
export function pattern(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("pattern", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/polygon)
 */
export function polygon(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("polygon", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/polyline)
 */
export function polyline(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("polyline", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/radialGradient)
 */
export function radial_gradient(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("radialGradient", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/rect)
 */
export function rect(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("rect", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/script)
 */
export function script(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("script", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/set)
 */
export function set(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("set", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/stop)
 */
export function stop(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("stop", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/style)
 */
export function style(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("style", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/svg)
 */
export function svg(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("svg", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/switch)
 */
export function switch$(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("switch", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/symbol)
 */
export function symbol(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("symbol", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/text)
 */
export function text(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("text", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/textPath)
 */
export function text_path(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("textPath", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/title)
 */
export function title(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("title", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/tspan)
 */
export function tspan(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("tspan", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/use)
 */
export function use_(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("use", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/SVG/Element/view)
 */
export function view(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("view", props, children, convert_children);
}
